import React, { createContext, useContext, useState, useCallback } from 'react';
import { isEqual, isFunction } from 'lodash';
import { initialFilter, initialStock } from './StocksUIHelpers';

const StocksUIContext = createContext();

export function useStocksUIContext() {
  return useContext(StocksUIContext);
}

export const StockUIConsumer = StocksUIContext.Consumer;

export function StocksUIProvider({ StocksUIEvents, children }) {
  const [createdStock, setCreatedStockBase] = useState(initialStock);
  const [stockForView, setStockForViewBase] = useState(initialStock);
  const [queryParams, setQueryParamsBase] = useState(initialFilter);

  const setQueryParams = useCallback(
    (nextQueryParams) => {
      setQueryParamsBase((prevQueryParams) => {
        if (isFunction(nextQueryParams)) {
          nextQueryParams = nextQueryParams(prevQueryParams);
        }
        if (isEqual(prevQueryParams, nextQueryParams)) {
          return prevQueryParams;
        }
        return nextQueryParams;
      });
      console.log('StocksUIProvider.setQueryParams', queryParams);
    },
    [queryParams]
  );

  const setCreatedStock = useCallback((nextCreatedStock) => {
    setCreatedStockBase((prevCreatedStock) => {
      if (isFunction(nextCreatedStock)) {
        nextCreatedStock = nextCreatedStock(prevCreatedStock);
      }
      if (isEqual(prevCreatedStock, nextCreatedStock)) {
        return prevCreatedStock;
      }
      return nextCreatedStock;
    });
  }, []);

  const setStockForView = useCallback((nextStockForView) => {
    setStockForViewBase((prevStockForView) => {
      if (isFunction(nextStockForView)) {
        nextStockForView = nextStockForView(prevStockForView);
      }
      if (isEqual(prevStockForView, nextStockForView)) {
        return prevStockForView;
      }
      return nextStockForView;
    });
  }, []);

  const value = {
    queryParams,
    createdStock,
    stockForView,
    setQueryParams,
    setCreatedStock,
    setStockForView,
    initialStock,
    openViewStockDialog: StocksUIEvents.openViewStockDialog,
    openCreateStockDialog: StocksUIEvents.openCreateStockDialog,
    openDeleteStockDialog: StocksUIEvents.openDeleteStockDialog,
  };

  return (
    <StocksUIContext.Provider value={value}>
      {children}
    </StocksUIContext.Provider>
  );
}
